<template>
  <dtunes-modal @openModal="dialog = true" @closeModal="dialog = false">
    <template v-slot:button>
      <v-icon v-if="text == 'approve'">mdi-plus</v-icon>
      <v-icon v-if="text == 'decline'">mdi-minus</v-icon>
      {{ text }}
    </template>
    <template v-slot:content>
      <v-card class="pad-10">
        <v-card-title class="d-flex justify-center">
          <p class="text-center">SECURITY PIN</p>
        </v-card-title>
        <v-card-text>
          <div ref="form">
            <div class="mb-5">
              <v-text-field class="centered bold larger" v-model="pin" type="password" color="auto"
                disabled></v-text-field>
              <PinPad @key-pressed="onKeyPressed" />
            </div>
            <default-button @click="upload" :loading="loading">{{ text }}</default-button>
          </div>
        </v-card-text>
      </v-card>
    </template>
  </dtunes-modal>
</template>

<script>
// ============= IMPORT COMPONENT ===========
import DtunesModal from "@/components/dtunes-modal.vue";
import DefaultButton from "@/components/Buttons/default-button.vue";
import PinPad from "./pin-pad.vue";
import app from '@/main'

// =========== IMPORT SERVICES =============
import { PermissionService, CryptoService } from "@/services";

import { analytics, LogEvent } from "@/utils/firebase";

export default {
  components: {
    DtunesModal,
    DefaultButton,
    PinPad
  },
  props: {
    item: Object,
    text: String
  },
  data: () => ({
    pin: "",
    email: "",
    phonenumber: "",
    Permissions: [],
    loading: false,
    value: [],
    emailRules: [],
    phonenumberRules: [],
    formRules: [(v) => !!v || "This field is required"],
  }),
  computed: {
    isComplete() {
      return this.email && this.phonenumber && this.value.length > 0;
    },
  },
  mounted() {
    this.getPermissions();
  },
  methods: {
    async upload() {
      try {

        if(this.pin.length < 4 || this.pin.length > 8) return app.$store.dispatch('toast', {
				message : 'Pin is less than 4 digits or greater than 8',
				variant: 'error'
			});
      //check if the trade is not closed
      if(this.item.status == 'approved' || this.item.status == 'declined') return app.$store.dispatch('toast', {
				message : 'The trade has already been acted on',
				variant: 'error'
			});
      this.loading = true;
      // upload the action to the server
       let body = {
        tradeId: this.item.id,
         pin: this.pin,
        action: this.text == 'approve'? 'accept': 'reject'
       }

      let data = await CryptoService.closeCoinTrade(body);
      if(data.status == 'success'){
        app.$store.dispatch('toast', {
				message : 'Action successful',
				variant: 'success'
			});
      this.loading = false;
      this.pin = ''; this.dialog = false;
      if(this.item.status == 'approved'){
        const result =  LogEvent( analytics,'crypto_trade_success', { trade: "card" });
        const mix =  this.$mixpanel.track('crypto_trade_success',{ trade: "card" });
       console.log("the result here", result, "mix panel", mix);
      }
      this.$emit('closeModal');
      this.$emit('refresh');
     
      }
      else{
        this.loading = false;
        this.pin ='';
        app.$store.dispatch('toast', {
				message : data.data.data.message,
				variant: 'error'
			});
      }



      } catch (error) {
        this.loading = false;
        this.pin ='';
       
      }
    },

  
    onKeyPressed(key) {
      if (key === "del") {
        this.pin = this.pin.slice(0, -1);
      } else if (this.pin.length < 8) {
        this.pin += key;
      }
    },
    async getPermissions() {
      const data = await PermissionService.getPermissions();
      this.Permissions = data;
    },
  },
};
</script>

<style>
.centered {
  text-align: center;
}

.bold {
  font-weight: bold;
}

.larger {
  font-size: 20px;
  /* Change the value to adjust the font size */
}
</style>